import { BASE_URL } from '../constants';

const photos = [
  {
    imgSrc: `${BASE_URL}/images/gallery/00-cartel-la-otra-isla.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/01-marta-maria-perez-bravo.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/02-sala-de-exposicion-la-otra-isla.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/03-2-angel-delgadoserie-memorias-acumuladas.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/04-angel-delgado-escape.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/05-humberto-diaz-un-poquito-suave-un-poquito-duro-como-a-ti-te-gusta.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/06-sala-de-exposicion-la-otra-isla.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/07-humberto-diaz-inflando-el-globo.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/08-sala-de-exposicion-la-otra-isla.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/09-raul-cordero-mas-de-lo-mismo.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/10-raul-cordero-mas-de-lo-mismo.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/11-reynier-leyva-novo-epilogo.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/12-sala-de-exposicion-la-otra-isla.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/13-luis-manuel-otero-donde-esta-mella.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/14-luis-garciga-alberca-sin-trampolin.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/15-luis-garciga-y-miguel-moya-censo.jpg`,
    altText: '',
  },
  {
    imgSrc: `${BASE_URL}/images/gallery/16-alexandre-arrechea-rostro-de-la-nacion.jpg`,
    altText: '',
  },
];
export default photos;
